export default __webpack_public_path__ + "images/sub-nav-bullets-close.png";